import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Observable } from 'rxjs';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { take } from 'rxjs/operators';
import { CompleteOrderBackendService } from '@complete-order/services/complete-order-backend.service';

@Component({
  selector: 'app-processing-order',
  templateUrl: './processing-order.component.html',
  styleUrls: ['./processing-order.co' + 'mponent.scss'],
})
export class ProcessingOrderComponent implements OnInit, OnDestroy {
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: BeforeUnloadEvent) {
    if (!this.showConfirmBeforeLeave) return;

    const message =
      'We are still processing your order, are you sure you want to leave?';
    $event.returnValue = message;
    return message;
  }
  showRefreshBox = false;

  hideLoader = false;

  showConfirmBeforeLeave = false;

  refreshBoxTimeout: ReturnType<typeof setTimeout> | undefined;
  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly viewOffersService: ViewOffersService,
    private readonly completeOrderBackendService: CompleteOrderBackendService
  ) {}

  ngOnInit() {
    this.completeOrderBackendService.isAtStageToPoll = true;
    this.viewOffersService.offersLoaded$.subscribe({
      next: (loaded) => {
        this.hideLoader = loaded;
        this.cdr.detectChanges();

        if (loaded) {
          // Timeout used to ensure external navigation does not get blocked by this initial load
          // This is important because if the order has been placed etc. we can navigate without confirmation here
          setTimeout(() => {
            this.showConfirmBeforeLeave = true;
          });

          this.startPollingOnApi();
        }
      },
    });

    this.refreshBoxTimeout = setTimeout(() => {
      this.showRefreshBox = true;
      this.cdr.detectChanges();
    }, 60000);
  }

  startPollingOnApi() {
    this.viewOffersService.offers$.pipe(take(1)).subscribe({
      next: (offer) => {
        this.completeOrderBackendService
          .setupPollingAPI(offer.offer.offer_reference)
          .subscribe();
      },
    });
  }

  ngOnDestroy() {
    this.completeOrderBackendService.isAtStageToPoll = false;
    if (this.refreshBoxTimeout) {
      clearTimeout(this.refreshBoxTimeout);
    }
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (
      !this.showConfirmBeforeLeave ||
      !this.completeOrderBackendService.isProcessingPayment
    )
      return true;

    return new Observable((observer) => {
      const acknowledge = confirm('Are you sure you want to leave the page?');
      observer.next(acknowledge);
      observer.complete();
    });
  }
}
